<template>
  <div v-if="$store.getters.userRole === checkRole" class="settings">
    <div class="settings-container">
      <ul class="settings-menu">
        <li
          v-for="(name, index) in pages"
          :key="index"
          @mouseover="settingsVisibleHandler(name.slug)"
          @mouseleave="settingsVisibleHandler(name.slug)"
          class="settings-menu__name"
          :class="[slug === name.slug ? 'active' : '']">
          <span v-if="name.url !== '#'">
            <router-link
              :to="{ path: name.url }"
              active-class="active"
              class="settings-menu__name-link">{{ name.name }}</router-link>
          </span>

          <span v-if="name.url === '#'">
            {{ name.name }}
          </span>
        </li>
      </ul>

      <div class="settings-block">
        <div
          v-for="page in subPages"
          :key="page.slug"
          :class="[
            'settings-block-row',
            slug === 'my' ? 'settings-block_position' : ''
          ]">
          <div
            v-for="(category, index) in page.dropdown"
            :key="index"
            class="list">
            <p class="list__title">
              <router-link
                :to="{ path: category.url }"
                class="list-outer__item-link"
                :disabled="category.url === '#'"
                active-class="active">{{ category.name }}</router-link>
            </p>

            <ul class="list-outer">
              <li v-for="(subcategory, index) in category.links" :key="index">
                <span  class="list-outer__item">
                  <router-link
                    :to="{ path: subcategory.url }"
                    class="list-outer__item-link"
                    :disabled="subcategory.url === '#'"
                    active-class="active">{{ subcategory.name }}</router-link>
                </span>

                <ul v-if="subcategory.list" class="list-inner">
                  <li
                    v-for="(list, index) in subcategory.list"
                    :key="index"
                    class="list-inner__item">
                    <span>
                      <router-link
                        :to="{ path: list.url }"
                        class="list-outer__item-link"
                        :disabled="subcategory.url === '#'"
                        active-class="active">{{ list.name }}</router-link>
                    </span>

                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div
          @click="
            $store.dispatch(
              'SHOW_SETTINGS_MENU',
              !$store.getters.showSettingsMenu
            )
          "
          class="settings-block-close">
          <span class="settings-block-close__icon"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { MENU } from '@/utils/menu';
import { ROLE_SYSTEM_ADMIN } from '@/utils/const';

export default Vue.extend({
  data: () => ({
    pages: MENU.settingsMenu,
    settingsVisible: false,
    slug: 'ge',
  }),
  computed: {
    subPages() {
      return this.pages.filter((item) => item.slug == this.slug);
    },
    checkRole() {
      return ROLE_SYSTEM_ADMIN;
    },
  },
  methods: {
    settingsVisibleHandler(slug) {
      this.slug = slug;
      this.settingsVisible = !this.settingsVisible;
    },
  },
});
</script>

<style lang="scss">
.settings {
  width: 100%;
  background: #F3F3F3;

  a {
    &:not([disabled]):hover {
      text-decoration: underline;
    }
    &[disabled] {
      opacity: .4;
      pointer-events: none;
    }
  }

  &-container {
    @include flex(row, space-between, flex-start);
    width: 100%;
  }

  &-block {
    @include flex(column, space-between, flex-start);
    width: 100%;
    flex-wrap: nowrap;
    background-color: $color-white;
    align-self: stretch;
    padding: 26px 38px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
    position: relative;

    li {
      list-style-type: none;
    }

    &-row {
      @include flex(row, space-between, flex-start);
      width: 100%;
      flex-grow: 1;
      flex-wrap: wrap;

      .list {
        flex-grow: 1;
        margin-right: 40px;
        max-width: 250px;
        margin-bottom: 20px;
        min-width: 190px;

        li {
          color: $color-gray_dark;
        }

        &__title {
          font-weight: 500;
          font-size: 18px;
          color: $color-title;
          line-height: 32px;

          a {
            color: #18191C;
          }
        }

        &-outer {
          line-height: 28px;

          &__item-link {
            cursor: pointer;
            color: #5f5f5f;
          }
        }

        &-inner {
          line-height: 23px;

          &__item {
            position: relative;
            padding-left: 28px;

            &::before {
              content: "";
              position: absolute;
              left: 3px;
              height: 100%;
              width: 1px;
              background-color: $color-gray;
            }

            &::after {
              content: "";
              position: absolute;
              bottom: 50%;
              left: 3px;
              height: 1px;
              width: 20px;
              background-color: $color-gray;
            }

            &:last-child {
              &::before {
                height: 50%;
              }
            }
          }
        }
      }
    }

    &_position {
      justify-content: flex-start;

      .list {
        @include flex(column, center, flex-start);
        width: 247px;
        margin-right: 30px;
      }
    }

    &-close {
      position: absolute;
      width: 14px;
      height: 14px;
      cursor: pointer;
      right: 22px;
      top: 18px;
      background: url(/img/icons/icon_close.svg) no-repeat;
    }
  }

  &-item {
    @include flex(row, space-between, center);
  }

  &-menu {
    position: relative;
    width: 30%;

    &__name {
      @include flex(row, flex-start, center);
      min-height: 71px;
      font-weight: 500;
      font-size: 20px;
      padding: 0px 37px;
      transition: 0.3s background-color $transition;
      position: relative;
      z-index: 5;

      &::after {
        content: '';
        margin-left: auto;
        width: 8px;
        height: 8px;
        border-top: 2px solid #5F5F5F;
        border-right: 2px solid #5F5F5F;
        transform: rotate(45deg);
      }

      &-link {
        color: #000;
      }

      &.active {
        background: #fff;
      }
    }
  }
}

@media (max-width: 1366px) {
  .settings-block-row {
    justify-content: flex-start;

    .list {
      max-width: 200px;
    }
  }
}
</style>
